import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import OfficeSetupMember from '../../../components/UI/Member/OfficeSetupMember'
import {
  Label,
  Input,
  Button,
  Alert,
  Popover,
  PopoverHeader,
  PopoverBody,
  Breadcrumb,
  BreadcrumbItem,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  ModalFooter,
  Table,
} from 'reactstrap'
import Tooltip from '../../../components/UI/TooltipIcon/TooptipIcon'
import ErrorMessage from '../../../components/Message/ErrorMessage/ErrorMessage'
import { deepClone } from '../../../utils/copyObject'
import findIndex from 'lodash/findIndex'
import find from 'lodash/find'
import filter from 'lodash/filter'
import axios from '../../../axios'
import {
  profilePicValidityCheck,
  roleOptions,
  STRIPE_PUBLIC_KEY,
} from '../../../utils/constants'
import * as url from '../../../utils/url'
import addIcon from '../../../assets/plus.svg'
import { validateEmail } from '../../../utils/validations'
// import Loading from '../../../hoc/Loading/LoadingWithError';
import Loading from '../../../hoc/Loading/Loading'

import './InviteOfficeMates.css'
import { BiChart, BiPlus, BiTrashAlt, BiX } from 'react-icons/bi'
import { getTrivvyPlanDetailsPlanWise } from '../../trivia/data'
import { toastContainer } from '../../../utils/toast'
import { Link } from 'react-router-dom'
import { MdEventSeat, MdUpdate, MdUpgrade } from 'react-icons/md'
import UpgradePlanModal from '../../trivia/Components/UpgradePlanModal'
import { isMobile } from '../../../utils/deviceInfo'
import { TagsInput } from 'react-tag-input-component'

function InviteAdminsTrivvy({ open, onClose, user, ...props }) {
  const [currentAdmins, setCurrentAdmins] = useState(
    []
    // !isMobile ? [{ firstName: "", email: "", lastName: "", role: "Admin" }] : []
  )
  const [currentUsers, setCurrentUsers] = useState(
    []
    // !isMobile ? [{ firstName: "", email: "", lastName: "", role: "Admin" }] : []
  )
  const [errorMessages, setErrorMessages] = useState([])

  const [displayType, setDisplayType] = useState(1)

  const [totalUserSeats, setTotalUserSeats] = useState(0)
  const [previousAddedSeats, setPreviousAddedSeats] = useState(0)
  const [addedAdmins, setAddedAdmins] = useState([])
  const [addedUsers, setAddedUsers] = useState([])
  const [apiPlans, setApiPlans] = useState([])

  const [apiErrorMessage, setApiErrorMessage] = useState('')

  const plan = user.profile.organizationId.trivvyPlanType

  useEffect(() => {
    axios.get(url.getPaymentPlans).then(({ data }) => {
      setApiPlans(data.data)
      const plansArr = data.data
      axios
        .get(url.fetchUsers)
        .then(({ data }) => {
          const admins = data.data.filter((x) => x.role == 'Admin')
          const users = data.data.filter((x) => x.role !== 'Admin')

          setAddedUsers([...users])
          setAddedAdmins([...admins])
          setPreviousAddedSeats(admins.length)
          setTotalUserSeats(getTrivvyPlanDetailsPlanWise(plan, plansArr).seats)
        })
        .catch((err) => {
          console.log(err)
        })
    })
  }, [])

  const validate = () => {
    let specialChar = /[~`!#$%\^&*+=\\[\]\\';,/{}|\\":<>\?0-9]/g
    setErrorMessages([])
    let validInputs = 0
    const errMsgs = []
    for (let index = 0; index < currentAdmins.length; index++) {
      const obj = currentAdmins[index]
      console.log(obj)
      if (obj.email && validateEmail(obj.email)) {
        validInputs += 1
      } else {
        errMsgs.push(`Row ${index + 1} - Please enter valid email`)
      }

      if (obj.firstName) {
        if (specialChar.test(obj.firstName)) {
          errMsgs.push(
            `Row ${index +
              1} - Please enter valid first name should only contain alphabets`
          )
        }
      }
      if (obj.lastName) {
        if (specialChar.test(obj.lastName)) {
          errMsgs.push(
            `Row ${index +
              1} - Please enter valid last name should only contain alphabets`
          )
        }
      }
    }

    if (validInputs > 0 && validInputs > totalUserSeats - previousAddedSeats) {
      errMsgs.push(
        `You are trying to add ${validInputs} seats but your seats left are only ${
          totalUserSeats - previousAddedSeats < 0
            ? 0
            : totalUserSeats - previousAddedSeats
        }`
      )
    }

    setErrorMessages(errMsgs)

    if (errMsgs.length) {
      return false
    } else {
      return true
    }
  }

  const updateUser = (value, key, index) => {
    const array = [...currentAdmins]
    array[index][key] = value
    setCurrentAdmins(array)
  }

  const removeUser = (index) => {
    const array = [...currentAdmins]
    array.splice(index, 1)
    setCurrentAdmins(array)
  }

  const addUser = (value, key, index) => {
    const array = [...currentAdmins]
    array.push({
      email: '',
      firstName: '',
      lastName: '',
      role: 'Admin',
    })
    setCurrentAdmins(array)
  }

  const addAdminSeats = () => {
    if (validate()) {
      axios
        .post(url.uploadUsersForTrivvy, { data: currentAdmins })
        .then(({ data }) => {
          setApiErrorMessage(false)
          setAddedAdmins([...data.data.successRes, ...addedAdmins])
          setPreviousAddedSeats(
            previousAddedSeats + data.data.successRes.length
          )
          setCurrentAdmins([])
        })
        .catch((err) => {
          const message =
            err.response &&
            err.response.data &&
            err.response.data.errors.message
          setApiErrorMessage(message || 'Error while adding user seats')
        })
    }
  }
  const addUserSeats = () => {
    axios
      .post(url.uploadUsersForTrivvy, { data: currentUsers })
      .then(({ data }) => {
        setApiErrorMessage(false)
        setAddedUsers([...addedUsers, ...data.data.successRes])
        setCurrentUsers([])
      })
      .catch((err) => {
        const message =
          err.response && err.response.data && err.response.data.errors.message
        setApiErrorMessage(message || 'Error while adding user seats')
      })
  }

  const removeAddedAdmin = (id) => {
    let admins = [...addedAdmins]

    admins = admins.filter((x) => x._id != id)

    setAddedAdmins(admins)

    axios
      .put(url.changeRole(id), {
        role: 'User',
        currentRole: 'Admin',
        orgAdmin: false,
      })
      .then(({ data }) => {
        setPreviousAddedSeats(previousAddedSeats - 1)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const removeAddedUser = (id) => {
    let users = [...addedUsers]

    users = users.filter((x) => x._id != id)

    setAddedUsers(users)

    axios
      .delete(url.removeOfficeMate + id)
      .then(() => {})
      .catch(() => {
        console.log('Change Role Error')
      })
  }

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0
        ? user.firstName
        : isMobile
        ? user.email.split('@')[0]
        : 'N'
    let lastName =
      user.lastName && user.lastName.length > 0
        ? user.lastName
        : isMobile
        ? user.email.split('@')[1]
        : 'N'
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()
  }

  const redirectTomembers = () => {
    props.history.push('/home/users')
    onClose()
  }

  const onAddAdminSeatViaTags = (tags) => {
    const newUsers = tags.map((x) => ({
      email: x,
      firstName: '',
      lastName: '',
      role: 'Admin',
    }))

    setCurrentAdmins(newUsers)
  }
  const onAddUserSeatViaTags = (tags) => {
    const newUsers = tags.map((x) => ({
      email: x,
      firstName: '',
      lastName: '',
      role: 'User',
    }))

    setCurrentUsers(newUsers)
  }

  return (
    <Modal isOpen={open} className="trivvy-manage-user-admin-seats">
      <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>
        Manage Plan and User Seats
      </ModalHeader>

      <ModalBody className={isMobile && 'p-0'}>
        <div>
          <Row className={isMobile ? 'mx-0 px-0' : ''}>
            <Col
              className={`trivvy_plan_tab ${displayType == 1 ? 'active' : ''}`}
              onClick={() => {
                setDisplayType(1)
              }}
              xs={6}
              style={{
                flexDirection: isMobile ? 'column' : 'row',
              }}>
              Manage Plan{' '}
              {apiPlans.length > 0 && (
                <span>
                  ({getTrivvyPlanDetailsPlanWise(plan, apiPlans).name})
                </span>
              )}
            </Col>
            <Col
              className={`trivvy_plan_tab ${displayType == 2 ? 'active' : ''}`}
              onClick={() => {
                setDisplayType(2)
              }}
              xs={6}>
              User seats
            </Col>
          </Row>
        </div>
        <div className="p-1">
          {displayType == 1 && apiPlans.length ? (
            <UpgradePlanModal apiPlans={apiPlans} />
          ) : displayType == 2 ? (
            <div className="p-2">
              {apiErrorMessage ? (
                <Alert color="danger">{apiErrorMessage}</Alert>
              ) : apiErrorMessage === false ? (
                <Alert color="success" className="mt-4">
                  You have succesfully added user seats , Check{' '}
                  <b
                    className="text-info cursor-pointer"
                    onClick={() => redirectTomembers()}>
                    {' '}
                    Enterprise members{' '}
                  </b>{' '}
                  to see.
                </Alert>
              ) : (
                ''
              )}

              <div className="py-1">
                <p>
                  As per your selected plan you can add only{' '}
                  {totalUserSeats - previousAddedSeats >= 0
                    ? totalUserSeats - previousAddedSeats
                    : 0}{' '}
                  admins.
                </p>

                <p className="mt-2">
                  Admins added in past {previousAddedSeats}
                </p>

                <Row>
                  <Col md={6}>
                    <div style={{}}>
                      <div className="my-3 ext-signup-user-seats">
                        <Label>Add admins</Label>
                        <div className="ext-signup-user-seats-emails">
                          {' '}
                          *emails should be comma separated*{' '}
                        </div>
                        <TagsInput
                          separators={[',', 'Enter']}
                          value={currentAdmins.map((x) => x.email)}
                          onChange={(value) => {
                            if (
                              value.length >
                              totalUserSeats - previousAddedSeats
                            ) {
                              setErrorMessages([
                                "You can't add more emails as limit exceeded for adding admins",
                              ])
                            } else {
                              setErrorMessages([])
                              onAddAdminSeatViaTags(value)
                            }
                          }}
                          beforeAddValidate={(tag, existing) => {
                            if (
                              existing.length >=
                              totalUserSeats - previousAddedSeats
                            ) {
                              setErrorMessages([
                                "You can't add more emails as limit exceeded for adding admins",
                              ])
                              return false
                            } else {
                              return validateEmail(tag)
                            }
                          }}
                          placeHolder="Enter user emails"
                        />

                        {/* <small>
                        Maximum {maxUserSeatsAllowed} emails allowed
                      </small> */}
                      </div>

                      <Button
                        className="trivia-action-button-main mt-4"
                        onClick={addAdminSeats}
                        disabled={currentAdmins.length == 0}>
                        Add Admins <MdEventSeat className="ml-1" />
                      </Button>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div style={{}}>
                      <div className="my-3 ext-signup-user-seats">
                        <Label>Add users</Label>
                        <div className="ext-signup-user-seats-emails">
                          {' '}
                          *emails should be comma separated*{' '}
                        </div>
                        <TagsInput
                          separators={[',', 'Enter']}
                          value={currentUsers.map((x) => x.email)}
                          onChange={(value) => {
                            onAddUserSeatViaTags(value)
                          }}
                          beforeAddValidate={(tag, existing) => {
                            return validateEmail(tag)
                          }}
                          placeHolder="Enter user emails"
                        />
                      </div>

                      <Button
                        className="trivia-action-button-main mt-4"
                        onClick={addUserSeats}
                        disabled={currentUsers.length == 0}>
                        Add Users <MdEventSeat className="ml-1" />
                      </Button>
                    </div>
                  </Col>
                </Row>

                <div className="my-3 text-danger">
                  <ul>
                    {errorMessages.map((x) => (
                      <li>{x}</li>
                    ))}
                  </ul>
                </div>

                <div className="mt-3" id="added_admins">
                  <hr />
                  <h5>Added User Seats</h5>
                  <Table responsive hover className="trivvy-add-admin-tbl">
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th></th>
                      </tr>
                    </thead>

                    <tbody style={{ height: '400px', overflowY: 'auto' }}>
                      {addedAdmins.length || addedUsers.length
                        ? [...addedAdmins, ...addedUsers].map(
                            (userDoc, index) => {
                              return (
                                <tr
                                  key={userDoc._id}
                                  style={{ height: '60px' }}>
                                  <td>
                                    {userDoc && (
                                      <span
                                        className={`trivia_table_text_wrapper`}>
                                        {profilePicValidityCheck(
                                          userDoc.profilePic
                                        ) ? (
                                          <img
                                            src={userDoc.profilePic}
                                            height="35px"
                                            width="35px"
                                            style={{ borderRadius: '50%' }}
                                          />
                                        ) : (
                                          <span
                                            className="spotlightUserInitials"
                                            data-letters={getInitials(
                                              userDoc
                                            )}></span>
                                        )}{' '}
                                        {isMobile ? (
                                          <div
                                            style={{
                                              width: '50px',
                                            }}>
                                            {' '}
                                            {userDoc.firstName}{' '}
                                            {userDoc.lastName}{' '}
                                            {userDoc._id == user.profile._id &&
                                              '(You)'}
                                          </div>
                                        ) : (
                                          <span>
                                            {userDoc.firstName}{' '}
                                            {userDoc.lastName}{' '}
                                            {userDoc._id == user.profile._id &&
                                              '(You)'}
                                          </span>
                                        )}
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {' '}
                                    <div
                                      style={{
                                        width: isMobile ? '150px' : '400px',
                                        wordBreak: 'break-word',
                                      }}>
                                      {userDoc.email}
                                    </div>{' '}
                                  </td>
                                  <td>
                                    {' '}
                                    <div
                                      style={{
                                        width: isMobile ? '150px' : '400px',
                                        wordBreak: 'break-word',
                                      }}>
                                      {userDoc.role}
                                    </div>{' '}
                                  </td>
                                  <td>
                                    {userDoc._id == user.profile._id ? (
                                      ''
                                    ) : (
                                      <BiTrashAlt
                                        size={20}
                                        className="cursor-pointer"
                                        onClick={() => {
                                          if (userDoc.role == 'Admin') {
                                            removeAddedAdmin(userDoc._id)
                                          } else {
                                            removeAddedUser(userDoc._id)
                                          }
                                        }}
                                      />
                                    )}
                                  </td>
                                </tr>
                              )
                            }
                          )
                        : 'No User Seats added'}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </ModalBody>

      <ModalFooter>
        <Button onClick={() => onClose()}>Close</Button>
      </ModalFooter>
    </Modal>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  }
}

export default connect(mapStateToProps)(InviteAdminsTrivvy, axios)
